<template>
    <el-form :model="ruleForm2" width="550px" :rules="rules2" ref="ruleForm2" label-position="left" label-width="0px" class="demo-ruleForm login-container">
        <el-form-item prop="oldpass" label-width="100px" label="原密码">
            <el-input type="text" v-model="ruleForm2.oldpass" auto-complete="off" placeholder="原密码" show-password></el-input>
        </el-form-item>
        <el-form-item prop="newpass" label-width="100px" label="新密码" style="margin-top:10px">
            <el-input type="password" v-model="ruleForm2.newpass" auto-complete="off" placeholder="新密码" show-password></el-input>
        </el-form-item>
        <el-form-item prop="newlpass" label-width="100px" label="新密码确认">
            <el-input type="password" v-model="ruleForm2.newlpass" auto-complete="off" placeholder="新密码确认" show-password></el-input>
        </el-form-item>
        <el-form-item style="width:100%;">
            <el-button type="primary" style="width:100%;" @click.native.prevent="handleSubmit()">确认修改</el-button>
        </el-form-item>
    </el-form>
</template>
<script>
import { ModifyUserPwd } from "../api/api";
export default {
    data(){
        return{
           ruleForm2:{
                acid: null,
                creator:null,
                factoryid: null,
                newpass: null,
                newlpass:null,
                oldpass:null,
                uid: null
           } ,

           rules2: {
                oldpass: [
                    { required: true, message: "请输入原密码", trigger: "blur" }
                ],
                newpass: [
                    { required: true, message: "请输入新密码", trigger: "blur" },
                    { min: 6, message: '长度小于6个字符', trigger: 'blur' },
                    { max: 20, message: '长度大于 20个字符', trigger: 'blur' }
                ],
                 newlpass: [
                    { required: true, message: "请输入确认密码", trigger: "blur" },
                    { min: 6, message: '长度小于6个字符', trigger: 'blur' },
                    { max: 20, message: '长度大于 20个字符', trigger: 'blur' }
                ]
            },
        }
    },
    mounted(){

    },
    methods:{
        handleSubmit(ev){
           if(this.ruleForm2.newpass===this.ruleForm2.newlpass){
                this.$refs.ruleForm2.validate(valid => {
                    if (valid) {
                        var param ={
                            userpk:localStorage.getItem("userpk"),
                            oldPwd:this.ruleForm2.oldpass,
                            newPwd:this.ruleForm2.newpass,
                        }
                        ModifyUserPwd(param).then(res => {
                            if (res.code !== 0) {
                                this.$message({
                                    message: res.msg,
                                    type: "error"
                                });
                            } else {
                                this.$message({
                                    message: res.msg,
                                    type: "success"
                                });
                                location.href = "/html/login.html";
                            }
                        });

                    }
                })
           }else{
               this.$message({
                message:'新密码俩次输入不相同',
                type: "error"
               });

           }

        },
    }
}
</script>
<style lang="scss" scoped>
.login-container {
    /*box-shadow: 0 0px 8px 0 rgba(0, 0, 0, 0.06), 0 1px 0px 0 rgba(0, 0, 0, 0.02);*/
    -webkit-border-radius: 5px;
    border-radius: 5px;
    -moz-border-radius: 5px;
    background-clip: padding-box;
    margin: 180px auto;
    width: 350px;
    padding: 35px 35px 15px 35px;
    background: #fff;
    border: 1px solid #eaeaea;
    box-shadow: 0 0 25px #cac6c6;
    .title {
        margin: 0px auto 40px auto;
        text-align: center;
        color: #505458;
    }
    .remember {
        margin: 0px 0px 35px 0px;
    }
}
</style>
<style lang="css">

</style>



// WEBPACK FOOTER //
// changpwd.vue?1d3b22fa